import React, { PropsWithChildren, ReactElement } from 'react';
import { Content, FlexboxGrid, Col, Grid, Row, Text } from 'rsuite';
import PortalHeader from './PortalHeader';
import PageButtons, { PageButtonsProps } from './PageButtons';

interface GeneralPageLayoutProps extends PageButtonsProps {
  flow?: string;
  title?: string;
  showAccountDropdown?: boolean;
}

const GeneralPageLayout = ({
  flow,
  children,
  title,
  showAccountDropdown,
  ...buttons
}: PropsWithChildren<GeneralPageLayoutProps>): ReactElement => {
  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader
          flow={flow}
          showAccountDropdown={showAccountDropdown}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as="main"
        id="main-content"
        tabIndex={-1}
        colspan={24}
        aria-label={title}
      >
        <Content as="div">
          <Grid
            className="mt-24"
            fluid
          >
            <Row role="presentation">
              <Col
                role="presentation"
                xs={24}
              >
                <Grid className="mt-24 sm-mt-0 pv-24 sm-pb-0">
                  <Row>
                    <Col
                      xs={24}
                      lg={24}
                    >
                      {title && (
                        <Text
                          as="h1"
                          className="header-text-h3 mb-24"
                          style={{ marginLeft: '-3px' }}
                        >
                          {title}
                        </Text>
                      )}
                      <div className="content-section">{children}</div>
                      <PageButtons {...buttons} />
                    </Col>
                  </Row>
                </Grid>
              </Col>
            </Row>
          </Grid>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default GeneralPageLayout;
